import { useEffect, useMemo, useState } from 'react';
import { useDeepCompareEffect, useEffectOnce } from 'react-use';
import $ from 'jquery';
import { NavBar } from '../../../../themes/components/Navbar';
import { Sidebar } from '../../../../themes/components/Sidebar';
import { Toaster } from 'react-hot-toast';
import { CabecalhoNovoPedido } from '../../components/CabecalhoNovoPedido';
import { FormularioInfoEntrega } from '../../components/FormularioInfoEntrega';
import { TabelaListaItens } from '../../components/TabelaListaItens';
import { FooterMenuNovoPedido } from '../../components/FooterMenuNovoPedido';
import { usePedidos } from '../../../../contexts/Pedidos';
import { useHistory, useLocation } from 'react-router-dom';
import ReactLoading from 'react-loading';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Button from '@material-ui/core/Button';
import { Button as BtnPersonalizado } from '../../../../themes/components/Button';
import Typography from '@material-ui/core/Typography';
import { FiEdit } from 'react-icons/fi';
import { FaAngleDoubleDown, FaBullseye } from 'react-icons/fa';
import { RiMailSendFill } from 'react-icons/ri';
import { ArrayProdutosNovoPedido, Cliente, CondicaoPagamento, FormaPagamento, ItemResumoPrePedido, ResumoPrePedido, Transportadora } from '../../interfaces';
import { ModalAdicionarItemNovoPedido } from '../../components/Modais/ModalAdicionarProdutoNovoPedido';
import { Toast } from '../../../../themes/components/Toast';
import { useLocalStorage } from '../../../../contexts/LocalStorage';
import { ItemResumoPedido } from '../../components/ItemResumoPedido';
import { ItemPedidoEnviadoERP } from '../../components/ItemPedidoEnviadoERP';
import { useModals } from '../../../../contexts/Modals';
import { converterStringValorEmFloat, mascaraDataDDMMAAAA } from '../../../../util/fieldMasks';
import moment from 'moment';
import { buscarTransportadoraERP } from '../../apis/servicePedidoConsulta';
import { validarQuantidadeCorte, validarToleranciaPreco } from '../../../../util/rulesSale';


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
            height: '87.9%',
            overflowY: 'scroll'
        },
        button: {
            marginTop: "2em",
            marginLeft: "-3.3em",
            backgroundColor: "#0252a8",
            '&:hover': {
                backgroundColor: "#00438b",
            },
        },
        buttonEnviar: {
            backgroundColor: "green",
            '&:hover': {
                backgroundColor: "rgb(0, 97, 0)",
            },
        },
        buttonEnviarHover: {
            marginTop: "2em",
            marginLeft: "-3.3em",
            backgroundColor: ""
        },
        actionsContainer: {
            marginBottom: theme.spacing(2),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }
    }),
);

interface PedidosEnviados {
    mensagem: string
    numped: string
    codemp: string
    resumoId: number
    status: string
    tipo: string
    corte: string
}

export const NovoPedido = () => {
    let location: any = useLocation();
    const {
        buscarClientes,
        buscarCondPGTO,
        buscarFormaPGTO,
        novoPedido,
        setNovoPedido,
        itensDigitacaoPedido,
        salvarPrePedido,
        gerarResumoParaPrePedido,
        tiposFrete,
        enviarPedidoParaERP,
        idPrePedido,
        enviarPedidosPorEmail,
        setIdPrePedido,
        setItensDigitacaoPedido,
        updatePrePedido,
        buscarItensPedido,
        atualizaSaldoPrePedido,
        deletarPrePedido,
        buscarTransportadora } = usePedidos();
    const { setMensagem,
        setShowModalInfo,
        setShowModalProgress,
        showModalProgress,
        showModalInfo,
        mensagem,
        mostrarInfoOK,
        mostrarModalProgress } = useModals();
    const { getFromSessionStorage } = useLocalStorage();
    const classes = useStyles();
    const [activeStep, setActiveStep] = useState<number>(0);
    const [totalValuePedido, setTotalValuePedido] = useState<number>(0);
    const [totalQuantidadePedido, setTotalQuantidadePedido] = useState<number>(0);
    const [selected, setSelected] = useState<string[]>([]);
    const steps = getSteps();
    const [fieldCondPagamento, setFieldCondPagamento] = useState<CondicaoPagamento>();
    const [fieldFormaPagamento, setFieldFormaPagamento] = useState<FormaPagamento>();
    const [fieldCliente, setFieldCliente] = useState<Cliente>();
    const [fieldTranportadora2, setFieldTranportadora2] = useState<Transportadora>();
    const [fieldDataEntrega, setFieldDataEntrega] = useState<string>();
    const [fieldFrete, setFieldFrete] = useState<string>("");
    const [showModalAddItens, setShowModalAddItens] = useState<boolean>(false);
    const [loadingResumo, setLoadingResumo] = useState<boolean>(false);
    const [loadingEnviandoERP, setLoadingEnviandoERP] = useState<boolean>(false);
    const [statusPedidoEnviadoERP, setStatusPedidoEnviadoERP] = useState<boolean>(false);
    const [resumosEmEdicao, setResumosEmEdicao] = useState<number>(0);
    const [itensNaoEnviadosERP, setItensNaoEnviadosERP] = useState<boolean>(true);
    const [resumosPedidos, setResumosPedidos] = useState<ResumoPrePedido[]>();
    const [listaPedidosEnviados, setListaPedidosEnviados] = useState<PedidosEnviados[]>([]);
    const [processoFinalizado, setProcessoFinalizado] = useState<boolean>(false);
    const [idItemErro, setIdItemErro] = useState<string>("");
    const [value, setValue] = useState(0)
    let history = useHistory();

    //Avança para o próximo passo
    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    //Volta um passo
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    //Seleciona um passo específico da digitação do pedido
    const handleStep = (step: number) => {
        setActiveStep(step);
    };

    //Essa função limpa tudo para um próximo pedido
    const handleReset = () => {
        setActiveStep(0);
        setFieldCliente(undefined);
        setFieldCondPagamento(undefined);
        setFieldFormaPagamento(undefined);
        setFieldTranportadora2(undefined);
        setIdPrePedido(undefined);
        setItensDigitacaoPedido([]);
        setResumosPedidos([]);
        setListaPedidosEnviados([]);
        setItensNaoEnviadosERP(true);
        setNovoPedido({
            "empresa": 2,
            "filial": 1,
            "cliente": 0,
            "representante": 0,
            "formapag": "",
            "condpag": 0,
            "observacao": "",
            "cpfcnpj": 0,
            "valor": 0,
            "itens": 0,
            "quantidade": 0,
            "transportadora2": 0,
            "tipofrete": "",
            "tipomoeda": getFromSessionStorage("pedDol") === "S" ? "D" : "R",
            "dataentrega": "",
            "nomecliente": "",
            "nomeformapag": "",
            "nomecondpag": "",
            "produtos": []
        });
        setFieldFrete("");
        setFieldDataEntrega("");
        setProcessoFinalizado(false);
        setIdItemErro("");
    };

    function round(num: any, places: any) {
        if (!("" + num).includes("e")) {
            // @ts-ignore
            return +(Math.round(num + "e+" + places) + "e-" + places);
        } else {
            let arr = ("" + num).split("e");
            let sig = ""
            if (+arr[1] + places > 0) {
                sig = "+";
            }
            // @ts-ignore
            return +(Math.round(+arr[0] + "e" + sig + (+arr[1] + places)) + "e-" + places);
        }
    }
    //Esse efeito é usado para calcular a soma to valor total dos itens adicionados
    //Ele é usado pela tela atual e pelo rodapé
    useEffect(() => {
        let total = 0.0;
        let qtdTotal = 0
        itensDigitacaoPedido.forEach((option) => {
            if (option.valortotal !== undefined) {
                total += round(option.valortotal, 2);
            } else {
                if (option.quantidade !== '') {
                    total += round(parseFloat(option.pretab) * parseFloat(option.quantidade), 2);
                }
            }
            if (option.quantidade !== '') {
                qtdTotal += parseFloat(option.quantidade);
            }
        })
        setTotalValuePedido(total);
        setTotalQuantidadePedido(qtdTotal);
    }, [itensDigitacaoPedido, novoPedido, showModalAddItens, selected, value]);


    //Obter a descrição do tipo de frete
    function getSelectedFrete() {
        for (let index = 0; index < tiposFrete.length; index++) {
            const element = tiposFrete[index];
            if (element.cod === fieldFrete) {
                return element.desc
            }
        }
        return "";
    }

    const hoje = () => {
        return moment().format("DD/MM/YYYY");
    }

    useEffect(() => {
        if (idPrePedido !== undefined) {
            salvarAndamentoPedido();
        }
    }, [itensDigitacaoPedido]);

    //Monta o pedido com as informações passadas até então digitadas
    function preparaPedido(status: string = "1") {
        let temPedido = novoPedido;

        //Adicionando cabeçalho
        if (fieldCliente !== undefined) {
            temPedido.cliente = parseInt(fieldCliente.codcli);
            temPedido.cpfcnpj = parseInt(fieldCliente.cgccpf);
            temPedido.nomecliente = fieldCliente.nomcli;
        } else {
            if (status !== "1")
                Toast("error", "Campo cliente não preenchido! ");
            return false;
        }
        if (status !== "1") {
            if (fieldCondPagamento !== undefined) {
                temPedido.condpag = parseInt(fieldCondPagamento.codcpg);
                temPedido.nomecondpag = fieldCondPagamento.descpg;
            } else {
                Toast("error", "Campo Condição de Pagamento não preenchido!");
                return false;
            }
        } else {
            if (fieldCondPagamento !== undefined) {
                temPedido.condpag = parseInt(fieldCondPagamento.codcpg);
                temPedido.nomecondpag = fieldCondPagamento.descpg;
            } else {
                temPedido.condpag = 1;
                temPedido.nomecondpag = "À VISTA";
            }
        }

        if (status !== "1") {
            if (fieldFormaPagamento !== undefined) {
                temPedido.formapag = fieldFormaPagamento.codfpg;
                temPedido.nomeformapag = fieldFormaPagamento.desfpg;
            } else {
                Toast("error", "Campo Condição de Pagamento não preenchido!");
                return false;
            }
        } else {
            if (fieldFormaPagamento !== undefined) {
                temPedido.formapag = fieldFormaPagamento.codfpg;
                temPedido.nomeformapag = fieldFormaPagamento.desfpg;
            } else {
                temPedido.formapag = "1"
                temPedido.nomeformapag = "DINHEIRO";
            }
        }

        //Informações do Representante
        let user_codrep = "";
        let user_empresa = "";
        let user_filial = "";
        let user_codtab = "";
        if (getFromSessionStorage("user_codrep") !== null) {
            // @ts-ignore
            user_codrep = getFromSessionStorage("user_codrep")
        } else {
            Toast("error", "Erro nas Informações do usuário");
            return false;
        }
        if (getFromSessionStorage("user_empresa") !== null) {
            // @ts-ignore
            user_empresa = getFromSessionStorage("user_empresa")
        } else {
            Toast("error", "Erro nas Informações do usuário");
            return false;
        }
        if (getFromSessionStorage("user_filial") !== null) {
            // @ts-ignore
            user_filial = getFromSessionStorage("user_filial")
        } else {
            Toast("error", "Erro nas Informações do usuário");
            return false;
        }
        if (getFromSessionStorage("user_codtab") !== null) {
            // @ts-ignore
            user_codtab = getFromSessionStorage("user_codtab")
        } else {
            Toast("error", "Erro nas Informações do usuário");
            return false;
        }
        temPedido.representante = parseInt(user_codrep);
        temPedido.empresa = parseInt(user_empresa);
        temPedido.filial = parseInt(user_filial);


        //Adicionando informações dos itens
        temPedido.quantidade = totalQuantidadePedido;
        //O to fixed é pra impedir valors com dezenas de casas decimais
        temPedido.valor = parseFloat(totalValuePedido.toFixed(2));
        temPedido.itens = itensDigitacaoPedido.length;
        if (fieldFrete !== undefined && fieldFrete !== "") {
            temPedido.tipofrete = fieldFrete;
        } else {
            if (status !== "1") {
                Toast("error", "Campo Frete não preenchido");
                return false;
            } else {
                temPedido.tipofrete = "X";
            }
        }

        //Não obrigatório
        if (fieldTranportadora2 !== undefined) {
            temPedido.transportadora2 = parseInt(fieldTranportadora2.codtra);
        } else {
            temPedido.transportadora2 = 0;
        }

        if (fieldDataEntrega !== undefined && fieldDataEntrega !== "") {
            temPedido.dataentrega = fieldDataEntrega;
        } else {
            if (status !== "1") {
                Toast("error", "Campo Data de Entrega não preenchido");
                return false;
            } else {
                temPedido.dataentrega = hoje()
            }
        }



        let temProdutos: ArrayProdutosNovoPedido = [];
        for (let index = 0; index < itensDigitacaoPedido.length; index++) {
            const element = itensDigitacaoPedido[index];
            if (element.situacaoItem === undefined || element.situacaoItem === "1") {
                let preco = element.precoVenda !== undefined && element.precoVenda !== element.pretab ? converterStringValorEmFloat(element.precoVenda) : element.pretab;
                let corte = typeof element.quantidadecorte === "number" ? element.quantidadecorte : 0
                //console.log(element.codder)
                //console.log(preco)
                temProdutos.push({
                    "empresa":element.codemp,
                    "produto": element.codpro,
                    "derivacao": element.codder,
                    "quantidade": parseFloat(element.quantidade),
                    "container": element.codctn,
                    "precoTabela": parseFloat(element.pretab),
                    "tabela": user_codtab,
                    "preco": parseFloat(preco),
                    "nomeproduto": element.nomeproduto ? element.nomeproduto : 'Nao Identificado 2',
                    "disponibilidade": parseFloat(element.salime) + parseFloat(element.salpro),
                    "desconto": 0,
                    "representante": parseInt(user_codrep),
                    "agrupamento": element.codclc,
                    "quantidadecorte": corte,
                    "nomederivacao": element.desder,
                    "previsaocontainer": element.datprv
                })
            }
        }
        if (temProdutos.length > 0) {
            temPedido.produtos = temProdutos;
        } else {
            if (status !== "1")
                Toast("error", "Erro ao adicionar itens ao pedido");
            return false;
        }

        //Salvando pedido finalizado no hook
        //console.log(temPedido)
        setNovoPedido(temPedido);
        return true;
    }

    //Verifica se os campos do cabeçalho estão preenchidos e se tem ao menos um item adicionado
    function checarItensAdicionados() {
        if (itensDigitacaoPedido.length > 0) {
            return true;
        } else {
            return false;
        }
    }

    //Validando que informações de envio estão preenchidas
    function checarInfoEnvio() {
        if (fieldFrete !== "" &&
            fieldDataEntrega !== undefined && fieldDataEntrega.length === 10) {
            return true;
        } else {
            return false;
        }
    }

    //Enviar prepedido e gerar Resumo
    function gerarResumoPedido() {
        async function processar() {
            await salvarPrePedido(novoPedido, history)
                .then(res => {
                    if (res === -1) {
                        mostrarInfoOK("O Integrador não informou um ID de pré-pedido.");
                    } else {
                        mostrarModalProgress("Gerando resumo do Pré-Pedido");
                        getResumo(res);
                    }
                })
                .catch(err => {
                    console.log(err);
                    mostrarInfoOK("Falha ao tentar salvar o pré-pedido", err);
                })
        }
        async function atualizar(id: number) {
            await updatePrePedido(novoPedido, id, history)
                .then(res => {
                    setShowModalProgress(false);
                    if (idPrePedido !== undefined) {
                        mostrarModalProgress("Gerando resumo do Pré-Pedido");
                        getResumo(idPrePedido);
                    } else {
                        mostrarInfoOK("Falha ao gerar o resumo do Pré-Pedido ", "ID não encontrado!");
                    }
                })
                .catch(err => {
                    console.log(err);
                    setShowModalProgress(false);
                    mostrarInfoOK("Falha ao atualizar Pré-Pedido ", err);
                })
        }
        async function getResumo(res: number) {
            await gerarResumoParaPrePedido(res, history)
                .then(result => {
                    setResumosPedidos(result);
                    handleNext();
                    mostrarInfoOK("Pré-pedido salvo com sucesso: nº" + res, "Os itens adicionados irão gerar os pedidos a seguir");
                })
                .catch(error => {
                    console.log(error);
                    mostrarInfoOK("Erro ao gerar resumo", error);
                })
                .finally(() => {
                    setLoadingResumo(false);
                })
        }
        setLoadingResumo(true);
        setResumosEmEdicao(0);
        if (idPrePedido === undefined) {
            //Caso queira incluir validações antes de salvar o pré-pedido
            //caso de pedidos novos do zero
            if (preparaPedido()) {
                mostrarModalProgress("Salvando Pré-Pedido!")
                processar();
            }
        } else {
            //Aqui é onde ele atualiza o pré-pedido
            //Essa parte é chamada quando o pedido está sendo editado
            if (preparaPedido()) {
                mostrarModalProgress("Atualizando Pré-Pedido " + idPrePedido)
                atualizar(idPrePedido);
            }
        }
    }

    //Salvar o andamento do pre-pedido
    function salvarAndamentoPedido() {
        async function processar() {
            await salvarPrePedido(novoPedido, history)
                .then(res => {
                    setShowModalProgress(false);
                    mostrarInfoOK("Pré-Pedido " + res + " salvo com sucesso!");
                })
                .catch(err => {
                    console.log(err);
                    setShowModalProgress(false);
                    mostrarInfoOK("Falha ao salvar Pré-Pedido ", err);
                })
        }
        async function atualizar(id: number) {
            await updatePrePedido(novoPedido, id, history)
                .then(res => {
                    setShowModalProgress(false);
                    setShowModalInfo(false)
                    //mostrarInfoOK("Pré-Pedido " + id + " atualizado com sucesso!");
                })
                .catch(err => {
                    console.log(err);
                    setShowModalProgress(false);
                    mostrarInfoOK("Falha ao atualizar Pré-Pedido ", err);
                })
        }
        if (idPrePedido === undefined) {
            if (validarItensSelecionados()) {
                if (preparaPedido("1")) {
                    mostrarModalProgress("Salvando Pré-Pedido!")
                    processar();
                }
            }
        } else {
            if (validarItensSelecionados()) {
                if (preparaPedido("1")) {
                    mostrarModalProgress("Atualizando Pré-Pedido " + idPrePedido)
                    atualizar(idPrePedido);
                }
            }
        }
    }

    //Enviando pré-pedido para o ERP
    function enviarPrePedidoParaERP() {
        async function processarPedido(idPedido: number) {
            await enviarPedidoParaERP(idPedido, history)
                .then((res: any) => {
                    setListaPedidosEnviados(res);
                    setStatusPedidoEnviadoERP(true);
                    setLoadingEnviandoERP(false);
                    handleNext();
                })
                .catch((err: any) => {
                    console.log(err);
                    setStatusPedidoEnviadoERP(false);
                    if(JSON.stringify(err).includes("token")){
                        return false;
                    }
                    if (err.error !== undefined) {
                        mensagemErroEnvioPedidoERP(JSON.stringify(err.error));
                    } else {
                        mensagemErroEnvioPedidoERP(JSON.stringify(err));
                    }
                })
        }
        setLoadingEnviandoERP(true);
        if (idPrePedido !== undefined) {
            processarPedido(idPrePedido);
        } else {
            Toast("error", "Pré-Pedido não encontrado para ser enviado.");
        }
    }

    function mensagemErroEnvioPedidoERP(error: string) {
        setMensagem(<div className='mensagem-info-modal-loading'>
            <Typography>{`Houve uma falha no processamento do pedido`}</Typography>
            <Typography>{`Informação do erro:`}</Typography>
            <Typography>{error}</Typography>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <BtnPersonalizado onClick={() => [setActiveStep(1), setShowModalInfo(false)]} classBtn={"btn-notifications color-default"}>Verificar itens</BtnPersonalizado>
            </div>
        </div>);
        setShowModalInfo(true);
        setLoadingEnviandoERP(false);
    }

    function addItemFooter() {
        setShowModalAddItens(true);
        setActiveStep(1);
        setResumosPedidos([]);
    }

    function enviarPedidosParaCliente(envCliente: boolean) {
        let arrPedidos: string[] = []
        listaPedidosEnviados.forEach(element => {
            arrPedidos.push(element.numped);
        });
        enviarPedidosPorEmail(arrPedidos, envCliente, history)
            .then(res => {
                if (envCliente === true) {
                    if (res === true) {
                        mostrarInfoOK("Pedidos enviados com sucesso para o cliente");
                    } else {
                        mostrarInfoOK("O e-mail não foi enviado", "Contate o suporte!");
                    }
                }
            })
            .catch(err => {
                console.error("Erro ao enviar e-mail:")
                console.error(err);
            })
    }

    //Essa função retorna o título das etapadas da digitação do pedido
    //A lógica é baseada na quantidade de itens nesse array
    function getSteps() {
        return ['Cliente', 'Itens do Pedido', 'Informações de entrega', 'Pagamento', 'Resumo'];
    }

    //Varrendo itens adicionados para identificar se possue algum valor inválido
    function validarItensPedido() {
        if (validarItensSelecionados()) {
            if (idPrePedido !== undefined) {
                salvarAndamentoPedido();
            }
            setIdItemErro("");
            handleNext();
        }
    }

    //Função para verificar se o módulo da quantidade adicionada pela quantidade de corte é igual a 0
    function validarQtdCorte(qtdTotal: number, qtdCorte: number) {
        if (qtdCorte <= 1) {
            return true;
        }
        let res = qtdTotal % qtdCorte
        if (res === 0) {
            return true
        } else {
            return false
        }
    }

    function validarQuantidadeAdicionada(qtdTotal: number, saldo: number) {
        if (qtdTotal > saldo) {
            return false;
        } else {
            return true;
        }
    }

    function validarItensSelecionados() {
        //Varrendo cada item marcado na tabela de itens
        for (let index = 0; index < itensDigitacaoPedido.length; index++) {
            const elementEditado = itensDigitacaoPedido[index];
            if (elementEditado.pedido_erp === undefined || elementEditado.pedido_erp === "" || elementEditado.pedido_erp === null) {
                let quantidade = parseFloat(elementEditado.quantidade);
                if (quantidade > 0) {
                    //validando que o item ainda não foi inserido no pedido
                    if (validarQtdCorte(quantidade, elementEditado.quantidadecorte !== undefined && typeof elementEditado.quantidadecorte !== 'string' ? elementEditado.quantidadecorte : 1)) {
                        if (validarQuantidadeAdicionada(quantidade, parseFloat(elementEditado.salime) + parseFloat(elementEditado.salpro))) {
                            if (elementEditado.precoVenda === undefined || validarToleranciaPreco(parseFloat(elementEditado.precoVenda), parseFloat(elementEditado.pretab), parseFloat(elementEditado.tolmen), parseFloat(elementEditado.tolmai))) {
                                if (elementEditado.quantidadecorte === undefined || elementEditado.quantidadecorte === 'vazio' || validarQuantidadeCorte(parseInt(elementEditado.qtdpcs), parseInt(String(elementEditado.quantidadecorte)))) {
                                    //Item dentro das validações
                                    //console.log("Item ok para seguir");
                                } else {
                                    setIdItemErro(elementEditado.codder + elementEditado.codpro + elementEditado.codctn);
                                    mostrarInfoOK("Produto " + elementEditado.codpro + " Derivação " + elementEditado.codder + " - " + elementEditado.desder + " Está quantidade de corte acima do tamanho da peça: " + elementEditado.qtdpcs);
                                    return false;
                                }
                            } else {
                                setIdItemErro(elementEditado.codder + elementEditado.codpro + elementEditado.codctn);
                                mostrarInfoOK("Produto " + elementEditado.codpro + " Derivação " + elementEditado.codder + " - " + elementEditado.desder + " Está com preço fora da tolerância!");
                                return false;
                            }
                        } else {
                            setIdItemErro(elementEditado.codder + elementEditado.codpro + elementEditado.codctn);
                            mostrarInfoOK("Agrupamento " + elementEditado.codclc + " Produto " + elementEditado.codpro + " Derivação " + elementEditado.codder + " - " + elementEditado.desder + " não possue saldo suficiente!");
                            return false;
                        }
                    } else {
                        setIdItemErro(elementEditado.codder + elementEditado.codpro + elementEditado.codctn);
                        mostrarInfoOK("Agrupamento " + elementEditado.codclc + " Produto " + elementEditado.codpro + " Derivação " + elementEditado.codder + " - " + elementEditado.desder + " possue um valor de corte inválido!", "O campo quantidade precisa ser um multiplo do campo corte!");
                        return false;
                    }
                } else {
                    setIdItemErro(elementEditado.codder + elementEditado.codpro + elementEditado.codctn);
                    mostrarInfoOK("Agrupamento " + elementEditado.codclc + " Produto " + elementEditado.codpro + " Derivação " + elementEditado.codder + " - " + elementEditado.desder + " Precisa preencher o campo quantidade!");
                    return false;
                }
            }
        }
        return true;
    }

    //Efeito para mostrar loading das etapas da digitação do pedido
    useDeepCompareEffect(() => {
        if (activeStep === 4) {
            if (loadingResumo) {
                setShowModalProgress(true);
                setMensagem(
                    <div className='mensagem-info-modal-loading'>
                        <Typography>Gerando resumo do pré-pedido</Typography>
                        <ReactLoading type={"bars"} color={"#0252a8"} height={30} width={50} />
                    </div>
                )
            } else if (loadingEnviandoERP) {
                setShowModalProgress(true);
                setMensagem(
                    <div className='mensagem-info-modal-loading'>
                        <Typography>Enviando Pedidos</Typography>
                        <ReactLoading type={"bars"} color={"#0252a8"} height={30} width={50} />
                    </div>
                )
            } else {
                if (showModalProgress === true) {
                    setShowModalProgress(false);
                }
            }
        } else if (activeStep === steps.length) {
            if (showModalInfo === false) {
                if (statusPedidoEnviadoERP) {
                    let quantidadePedidos = listaPedidosEnviados.length;
                    let qtdSucesso = 0;
                    let qtdfalha = 0
                    for (let index = 0; index < quantidadePedidos; index++) {
                        const element = listaPedidosEnviados[index];
                        if (element.status.toLowerCase() === "erro") {
                            qtdfalha++
                        } else {
                            qtdSucesso++
                        }
                    }
                    if (qtdfalha > 0 && qtdSucesso > 0) {
                        enviarPedidosParaCliente(false);
                        setMensagem(
                            <div className="resetContainer mensagem-info-modal-loading">
                                <Typography>{qtdfalha > 1 ? `${qtdfalha} pedidos não foram enviados com sucesso!` : `${qtdfalha} pedido não foi enviado com sucesso!`}</Typography>
                                <div className="ui-error">
                                    <svg viewBox="0 0 87 87" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                            <g id="Group-2" transform="translate(2.000000, 2.000000)">
                                                <circle id="Oval-2" stroke="#F74444" stroke-width="4" cx="41.5" cy="41.5" r="41.5"></circle>
                                                <circle className="ui-error-circle" stroke="#FFFFFF" stroke-width="5" cx="41.5" cy="41.5" r="41.5"></circle>
                                                <path className="ui-error-line1" d="M22.244224,22 L60.4279902,60.1837662" id="Line" stroke="#F74444" stroke-width="3" stroke-linecap="square"></path>
                                                <path className="ui-error-line2" d="M60.755776,21 L23.244224,59.8443492" id="Line" stroke="#F74444" stroke-width="3" stroke-linecap="square"></path>
                                            </g>
                                        </g>
                                    </svg>
                                </div>
                                <Typography>{qtdSucesso > 1 ?
                                    `Deseja enviar um e-mail para o cliente dos ${qtdSucesso} pedidos enviados com sucesso?`
                                    :
                                    `Deseja enviar um e-mail para o cliente do pedido enviado com sucesso?`}
                                </Typography>
                                <div className='buttons-novo-pedido-modal-area'>
                                    <BtnPersonalizado onClick={() => [setShowModalInfo(false), enviarPedidosParaCliente(true)]} classBtn={"btn-footer-novo-pedido color-default "}>
                                        Enviar e-mail para cliente
                                    </BtnPersonalizado>
                                    <BtnPersonalizado onClick={() => [setShowModalInfo(false)]} classBtn={"btn-footer-novo-pedido color-default"}>
                                        Verificar pedidos
                                    </BtnPersonalizado>
                                </div>
                            </div>
                        );
                    } else if (qtdSucesso > 0) {
                        enviarPedidosParaCliente(false);
                        setMensagem(
                            <div className="resetContainer mensagem-info-modal-loading">
                                <Typography>{quantidadePedidos > 1 ? `${quantidadePedidos} Pedidos enviados com sucesso!` : "Pedido enviado com sucesso!"}</Typography>
                                <div className="success-animation">
                                    <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none" /><path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" /></svg>
                                </div>
                                <div className='buttons-novo-pedido-modal-area'>
                                    <BtnPersonalizado onClick={() => [handleReset(), setShowModalInfo(false)]} classBtn={"btn-footer-novo-pedido color-default"}>
                                        Digitar novo pedido
                                    </BtnPersonalizado>
                                    <BtnPersonalizado onClick={() => [setShowModalInfo(false), enviarPedidosParaCliente(true)]} classBtn={"btn-footer-novo-pedido color-default "}>
                                        Enviar e-mail para cliente
                                    </BtnPersonalizado>
                                    <BtnPersonalizado onClick={() => [setShowModalInfo(false)]} classBtn={"btn-footer-novo-pedido color-default"}>
                                        Verificar pedidos
                                    </BtnPersonalizado>
                                </div>
                            </div>
                        )
                    } else {
                        setMensagem(
                            <div className="resetContainer mensagem-info-modal-loading">
                                <Typography>{quantidadePedidos > 1 ? "Falha ao enviar pedidos!" : "Falha ao enviar pedido!"}</Typography>
                                <BtnPersonalizado onClick={() => [setShowModalInfo(false)]} classBtn={"btn-footer-novo-pedido color-red btn-final-novo-pedido"}>
                                    {quantidadePedidos > 1 ? "Verificar Pedidos" : "Verificar Pedido"}
                                </BtnPersonalizado>
                            </div>
                        )
                    }
                } else {
                    setMensagem(
                        <div className="resetContainer mensagem-info-modal-loading">
                            <Typography>Falha ao tentar enviar</Typography>
                            <BtnPersonalizado onClick={() => [setActiveStep(0), setShowModalInfo(false)]} classBtn={"btn-notifications color-red button-next-novo-pedido"}>
                                Verificar Informações
                            </BtnPersonalizado>
                        </div>
                    )
                }
                setShowModalInfo(true);
            }
        }
    }, [activeStep, loadingResumo, loadingEnviandoERP, statusPedidoEnviadoERP, steps]);

    //Essa função retorna o botão que avança de uma etapa da digitação para a próxima
    //Essa função retorna o botão que finaliza a digitação na ultima etapa
    function mostrarBotaoAvancar() {
        switch (activeStep) {
            case 0:
                if (fieldCliente !== undefined) {
                    return (
                        <BtnPersonalizado
                            onClick={handleNext}
                            classBtn={"btn-footer-novo-pedido color-default button-next-novo-pedido"}
                            disabled={false}
                        >
                            <> Avançar<FaAngleDoubleDown style={{ marginLeft: '0.5em', marginTop: '-0.1em' }} /></>
                        </BtnPersonalizado>
                    )
                } else {
                    return (
                        <BtnPersonalizado
                            onClick={() => { }}
                            classBtn={"btn-footer-novo-pedido button-next-novo-pedido"}
                            disabled={true}
                        >
                            <> Avançar<FaAngleDoubleDown style={{ marginLeft: '0.5em', marginTop: '-0.1em' }} /></>
                        </BtnPersonalizado>
                    )
                }
            case 1:
                if (checarItensAdicionados() && itensNaoEnviadosERP === true) {
                    return (
                        <div style={{ marginTop: "-2em" }}>
                            <BtnPersonalizado
                                onClick={validarItensPedido}
                                classBtn={"btn-footer-novo-pedido color-default button-next-novo-pedido"}
                                disabled={false}
                            >
                                <> Avançar<FaAngleDoubleDown style={{ marginLeft: '0.5em', marginTop: '-0.1em' }} /></>
                            </BtnPersonalizado>
                        </div>
                    )
                } else {
                    return (
                        <div style={{ marginTop: "-3em" }}>
                            <BtnPersonalizado
                                onClick={() => { }}
                                classBtn={"btn-footer-novo-pedido button-next-novo-pedido"}
                                disabled={true}
                            >
                                <> Avançar<FaAngleDoubleDown style={{ marginLeft: '0.5em', marginTop: '-0.1em' }} /></>
                            </BtnPersonalizado>
                        </div >
                    )
                }
            case 2:
                if (checarInfoEnvio()) {
                    return (
                        <BtnPersonalizado
                            onClick={() => handleNext()}
                            classBtn={"btn-footer-novo-pedido color-default button-next-novo-pedido"}
                            disabled={false}
                        >
                            <> Avançar<FaAngleDoubleDown style={{ marginLeft: '0.5em', marginTop: '-0.1em' }} /></>
                        </BtnPersonalizado>
                    )
                } else {
                    return (
                        <BtnPersonalizado
                            onClick={() => { }}
                            classBtn={"btn-footer-novo-pedido button-next-novo-pedido"}
                            disabled={true}
                        >
                            <> Avançar<FaAngleDoubleDown style={{ marginLeft: '0.5em', marginTop: '-0.1em' }} /></>
                        </BtnPersonalizado>
                    )
                }
            case 3:
                if (fieldCondPagamento === undefined || fieldFormaPagamento === undefined) {
                    return (
                        <BtnPersonalizado
                            onClick={() => { }}
                            classBtn={"btn-footer-novo-pedido button-next-novo-pedido"}
                            disabled={true}
                        >
                            <> Avançar<FaAngleDoubleDown style={{ marginLeft: '0.5em', marginTop: '-0.1em' }} /></>
                        </BtnPersonalizado>
                    )
                } else {
                    return (
                        <BtnPersonalizado
                            onClick={() => gerarResumoPedido()}
                            classBtn={"btn-footer-novo-pedido color-default button-next-novo-pedido"}
                            disabled={false}
                        >
                            <> Avançar<FaAngleDoubleDown style={{ marginLeft: '0.5em', marginTop: '-0.1em' }} /></>
                        </BtnPersonalizado>
                    )
                }
            case 4:
                if (loadingEnviandoERP === true || resumosEmEdicao > 0) {
                    return (
                        <div className='resumo-pedidos-area-pre'>
                            <button
                                className="prepedidoqtd"
                                onClick={() => { }}>
                                <span>Pré-pedido:</span> {idPrePedido !== undefined ? idPrePedido : ""}
                            </button>
                            <BtnPersonalizado
                                onClick={() => { }}
                                classBtn={"btn-footer-novo-pedido button-next-novo-pedido"}
                                disabled={true}
                            >
                                <> {resumosPedidos !== undefined && resumosPedidos?.length > 1 ? "ENVIAR PEDIDOS" : "ENVIAR PEDIDO"}<RiMailSendFill style={{ marginLeft: '0.5em', marginTop: '-0.1em' }} /></>
                            </BtnPersonalizado>
                            <div style={{marginRight:"2em", width: "100px"}}> </div>
                        </div>
                    )
                } else {
                    return (
                        <div className='resumo-pedidos-area-pre'>
                            <button className="prepedidoqtd" >
                                <span>Pré-pedido:</span> {idPrePedido !== undefined ? idPrePedido : ""}
                            </button>
                            <BtnPersonalizado
                                onClick={() => enviarPrePedidoParaERP()}
                                classBtn={"btn-footer-novo-pedido color-green button-next-novo-pedido"}
                                disabled={false}
                            >
                                <> {resumosPedidos !== undefined && resumosPedidos?.length > 1 ? "ENVIAR PEDIDOS" : "ENVIAR PEDIDO"}<RiMailSendFill style={{ marginLeft: '0.5em', marginTop: '-0.1em' }} /></>
                            </BtnPersonalizado>
                            <div style={{marginRight:"2em", width: "100px"}}> </div>
                        </div>
                    )
                }
            default:
                break;
        }
    }

    //Essa função retorna o que fica em cada etapa do pedido depois que é passado por ela
    //São os botões para que possa ser voltado a um step anterior
    function getStepInfoOption(step: number) {
        $(function () {
            setTimeout(function () {
                $('.novo-pedido-desc-form').fadeIn(200);
                $('.novo-pedido-desc-form').css({
                    display: 'block'
                });

            }, 500);

        });
        switch (step) {
            case 0:
                return (
                    <button
                        className="novo-pedido-desc-form btn-edit-desc-novo-pedido"
                        disabled={itensNaoEnviadosERP === true && processoFinalizado === false ? false : true}
                        onClick={() => handleStep(0)}>
                        <span>Cliente:</span> {"[" + fieldCliente?.codcli + "] " + fieldCliente?.nomcli}
                        <FiEdit size={20} />
                    </button>
                )
            case 1:
                return (
                    <button
                        disabled={itensNaoEnviadosERP === true && processoFinalizado === false ? false : true}
                        className="novo-pedido-desc-form btn-edit-desc-novo-pedido"
                        onClick={() => handleStep(1)}>
                        <span>Total de itens: </span> {itensDigitacaoPedido.length}
                        <span>Valor Total: </span> {totalValuePedido.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                        <FiEdit size={20} />
                    </button>
                )
            case 2:
                return (
                    <button
                        disabled={itensNaoEnviadosERP === true && processoFinalizado === false ? false : true}
                        className="novo-pedido-desc-form btn-edit-desc-novo-pedido"
                        onClick={() => handleStep(2)}>
                        <span>Frete:</span> {getSelectedFrete()}
                        <span>Previsão Faturamento:</span> {fieldDataEntrega}
                        {fieldTranportadora2?.codtra ?
                            <><span>Redespacho:</span> {fieldTranportadora2?.codtra + " - " + fieldTranportadora2?.nomtra} </>
                            :
                            <></>
                        }
                        <FiEdit size={20} />
                    </button>
                )
            case 3:
                return (
                    <button
                        className="novo-pedido-desc-form btn-edit-desc-novo-pedido"
                        disabled={itensNaoEnviadosERP === true && processoFinalizado === false ? false : true}
                        onClick={() => handleStep(3)}>
                        <span>Condição de Pagamento:</span> {"[" + fieldCondPagamento?.codcpg + "] " + fieldCondPagamento?.descpg}
                        <span>Forma de Pagamento:</span> {"[" + fieldFormaPagamento?.codfpg + "] " + fieldFormaPagamento?.desfpg}
                        <FiEdit size={20} />
                    </button>
                )
            case 4:
                let tempArrayPedidosERP = listaPedidosEnviados;

                //Definindo se o processo foi finalizado com sucesso
                for (let index = 0; index < listaPedidosEnviados.length; index++) {
                    const element = listaPedidosEnviados[index];
                    if (element.status.toLowerCase() !== "ok") {
                        break;
                    }
                    if (index === listaPedidosEnviados.length - 1) {
                        setProcessoFinalizado(true);
                    }
                }

                /*Ordenando pedidos enviados
                1º imediato sem corte
                2º imediato com corte
                3º container sem corte
                4º container com corte
                */
                tempArrayPedidosERP.sort(function (a, b) {
                    let keyA = a.corte, keyB = b.corte;
                    // Compare the 2 strings
                    return keyA.localeCompare(keyB);
                });
                tempArrayPedidosERP.sort(function (a, b) {
                    let keyA = a.tipo, keyB = b.tipo;
                    if (keyA === "Imediato") {
                        return -1
                    }
                    if (keyB === "Imediato") {
                        return 1
                    }
                    // Compare the 2 strings
                    return keyA.localeCompare(keyB);
                });
                tempArrayPedidosERP.sort(function (a, b) {
                    if (a.tipo === "Imediato" && b.tipo === "Imediato") {
                        let keyA = a.corte, keyB = b.corte;
                        // Compare the 2 strings
                        return keyA.localeCompare(keyB);
                    } else {
                        return 0
                    }
                });
                return (
                    <div className="area-pedidos-enviados">
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <div style={{ width: '1em', height: '1em', backgroundColor: '#ff7979', borderRadius: '5px' }}></div>
                            <Typography style={{ fontWeight: 'bold', marginLeft: '0.5em' }}>Pedidos não enviados</Typography>
                            <div style={{ width: '1em', height: '1em', backgroundColor: '#64b999', borderRadius: '5px', marginLeft: '1em' }}></div>
                            <Typography style={{ fontWeight: 'bold', marginLeft: '0.5em' }}>Pedidos enviados</Typography>
                        </div>
                        {tempArrayPedidosERP?.map((pedido: PedidosEnviados) => {
                            return (
                                <ItemPedidoEnviadoERP key={pedido.numped} pedido={pedido} resumosPedidos={resumosPedidos} handleStep={handleStep} />
                            )
                        })}
                    </div>
                )
            default:
                return 'Opção desconhecida';
        }
    }

    //Essa função retorna o conteúdo de cada etapa da digitação do pedido
    function getStepContent(step: any) {
        switch (String(step)) {
            case "0":
                return (
                    <>
                        <CabecalhoNovoPedido
                            setFieldCliente={setFieldCliente}
                            fieldCliente={fieldCliente}
                        />
                    </>
                )
            case "1":
                return (
                    <TabelaListaItens
                        allowSelectitem={true}
                        setShowModalAddItens={setShowModalAddItens}
                        selected={selected} setSelected={setSelected}
                        value={value} setValue={setValue}
                        setItensNaoEnviadosERP={setItensNaoEnviadosERP}
                        itensNaoEnviadosERP={itensNaoEnviadosERP}
                        setIdItemErro={setIdItemErro}
                        idItemErro={idItemErro}
                        statusPedidoEnviadoERP={statusPedidoEnviadoERP}
                    />
                )
            case "2":
                return (
                    <>
                        <FormularioInfoEntrega
                            fieldTranportadora2={fieldTranportadora2}
                            getSelectedFrete={getSelectedFrete}
                            setFieldTranportadora2={setFieldTranportadora2}
                            fieldDataEntrega={fieldDataEntrega}
                            setFieldDataEntrega={setFieldDataEntrega}
                            setFieldFrete={setFieldFrete}
                        />
                    </>
                )
            case "3":
                return (
                    <>
                        <CabecalhoNovoPedido
                            setFieldCondPagamento={setFieldCondPagamento}
                            setFieldFormaPagamento={setFieldFormaPagamento}
                            fieldCondPagamento={fieldCondPagamento}
                            fieldFormaPagamento={fieldFormaPagamento}
                        />
                    </>
                )
            case "4":
                //console.log("resumosPedidos")
                //console.log(resumosPedidos)
                if (resumosPedidos !== undefined) {
                    let tempArrayResPedidos = resumosPedidos;

                    /*Ordenando resumos
                    1º imediato sem corte
                    2º imediato com corte
                    3º container sem corte
                    4º container com corte
                    */
                    tempArrayResPedidos.sort(function (a, b) {
                        let keyA = a.pedido_corte, keyB = b.pedido_corte;
                        // Compare the 2 strings
                        return keyA.localeCompare(keyB);
                    });
                    tempArrayResPedidos.sort(function (a, b) {
                        let keyA = a.numero_container, keyB = b.numero_container;
                        if (keyA === "999") {
                            return -1
                        }
                        if (keyB === "999") {
                            return 1
                        }
                        // Compare the 2 strings
                        return keyA.localeCompare(keyB);
                    });
                    tempArrayResPedidos.sort(function (a, b) {
                        if (a.numero_container === "999" && b.numero_container === "999") {
                            let keyA = a.pedido_corte, keyB = b.pedido_corte;
                            // Compare the 2 strings
                            return keyA.localeCompare(keyB);
                        } else {
                            return 0
                        }
                    });
                    return (
                        <div className="resumos-pedidos-area">
                            {tempArrayResPedidos?.map((resumo: ResumoPrePedido, index: number) => {
                                return (
                                    <div key={resumo.id} >
                                        <ItemResumoPedido
                                            pedido={resumo}
                                            numPed={index + 1}
                                            loadingProgress={showModalProgress}
                                            resumosEmEdicao={resumosEmEdicao}
                                            setResumosEmEdicao={setResumosEmEdicao}
                                            prevFatOrigin={fieldDataEntrega}
                                            resumosPedidos={resumosPedidos}
                                            setResumosPedidos={setResumosPedidos}
                                        />
                                    </div>
                                )
                            })}
                        </div>
                    )
                } else {
                    return <></>;
                }
            default:
                return 'Opção desconhecida';
        }
    }

    //Carregando valores dos campos para pedidos já existentes
    useEffectOnce(() => {
        async function carregandoDadosAnteriores() {
            const promise1 = buscarClientes(String(novoPedido.cliente), history)
                .then((res: Cliente[]) => {
                    setFieldCliente(res[0])
                })
                .catch((err: any) => {
                    console.log("Não foi possível atualizar o campo Cliente");
                })
            const promise2 = buscarCondPGTO(String(novoPedido.condpag), "", history)
                .then((res: CondicaoPagamento[]) => {
                    if (novoPedido.condpag !== 0)
                        setFieldCondPagamento(res[0])
                })
                .catch((err: any) => {
                    console.log("Não foi possível atualizar o campo Condição de Pagamento");
                })
            const promise3 = buscarFormaPGTO(novoPedido.formapag, "", history)
                .then((res: FormaPagamento[]) => {
                    if (novoPedido.formapag !== "")
                        setFieldFormaPagamento(res[0])
                })
                .catch((err: any) => {
                    console.log("Não foi possível atualizar o campo Forma de Pagamento");
                })

            Promise.all([promise1, promise2, promise3]).then((res: any) => {
                if (novoPedido.tipofrete !== "") setFieldFrete(novoPedido.tipofrete);
                if (novoPedido.dataentrega !== "") setFieldDataEntrega(novoPedido.dataentrega);
                setShowModalProgress(false);
                setShowModalInfo(false);
                handleStep(1);
            })
        }

        //Essa função só é chamada quando está carregando informações de um pré-pedido
        async function carregandoDadosAnterioresPrePedido(pedido: any) {
            const promise1 = buscarClientes(pedido.cod_cliente, history)
                .then((res: Cliente[]) => {
                    for (let index = 0; index < res.length; index++) {
                        const element = res[index];
                        if (element.codcli === String(pedido.cod_cliente)) {
                            setFieldCliente(res[index]);
                            break;
                        }

                        if (index === res.length - 1) {
                            mostrarInfoOK("Não foi possível carregar o cliente do pedido");
                        }
                    }
                })
                .catch((err: any) => {
                    console.log("Não foi possível atualizar o campo Cliente");
                })
            const promise2 = buscarCondPGTO(String(pedido.cod_condicao_pag), "", history)
                .then((res: CondicaoPagamento[]) => {
                    for (let index = 0; index < res.length; index++) {
                        const element = res[index];
                        if (element.codcpg === String(pedido.cod_condicao_pag)) {
                            setFieldCondPagamento(res[index]);
                            break;
                        }

                        if (index === res.length - 1) {
                            mostrarInfoOK("Não foi possível carregar o Condição de Pagamento");
                        }
                    }
                })
                .catch((err: any) => {
                    console.log("Não foi possível atualizar o campo Condição de Pagamento");
                })
            const promise3 = buscarFormaPGTO(pedido.cod_forma_pag, "", history)
                .then((res: FormaPagamento[]) => {
                    for (let index = 0; index < res.length; index++) {
                        const element = res[index];
                        if (element.codfpg === pedido.cod_forma_pag) {
                            setFieldFormaPagamento(res[index]);
                            break;
                        }

                        if (index === res.length - 1) {
                            mostrarInfoOK("Não foi possível carregar a forma de pagamento do pedido");
                        }
                    }
                })
                .catch((err: any) => {
                    console.log("Não foi possível atualizar o campo Forma de Pagamento");
                })
            function getTransp() {
                buscarTransportadora(pedido.cod_transportadora2, history)
                    .then((res: Transportadora[]) => {
                        for (let index = 0; index < res.length; index++) {
                            const element = res[index];
                            if (element.codtra === String(pedido.cod_transportadora2)) {
                                setFieldTranportadora2(res[index]);
                                break;
                            }

                            if (index === res.length - 1) {
                                mostrarInfoOK("Não foi possível carregar o Redespacho do pedido");
                            }
                        }
                    })
                    .catch((err: any) => {
                        console.log("Não foi possível atualizar o campo Forma de Pagamento");
                    })
            }

            Promise.all([promise1, promise2, promise3]).then((res: any) => {
                if (pedido.tipo_frete !== "") setFieldFrete(pedido.tipo_frete);
                if (pedido.cod_transportadora2 !== 0) getTransp();
                setFieldDataEntrega(undefined);
                setShowModalProgress(false);
                setShowModalInfo(false);
                handleStep(1);
            })
        }

        //caso tenha apenas caído a sessão e voltado
        if (location.state !== undefined && location.state.from !== undefined && location.state.from === "/login") {
            //Carregando informações nos campos
            setMensagem(
                <div className='mensagem-info-modal-loading'>
                    <Typography>Carregando informações</Typography>
                    <ReactLoading type={"bars"} color={"#0252a8"} height={30} width={50} />
                </div>
            )
            setShowModalProgress(true);
            if (novoPedido.cliente !== 0) {
                carregandoDadosAnteriores();
            } else {
                setShowModalProgress(false);
            }
            //Caso venha da tela de prepedido para edição
        } else if (location.state !== undefined && location.state.from !== undefined && location.state.from === "/prepedidos/consultar") {
            //Carregando informações nos campos
            setMensagem(
                <div className='mensagem-info-modal-loading'>
                    <Typography>Carregando informações</Typography>
                    <ReactLoading type={"bars"} color={"#0252a8"} height={30} width={50} />
                </div>
            )
            setShowModalProgress(true);
            carregandoDadosAnterioresPrePedido(location.state.Pedido);

            //Caso venha da cópia do pedido do ERP
        } else if (location.state !== undefined && location.state.from !== undefined && location.state.from === "/pedidos/consultar/modal") {
            handleReset();
            // Preparando cópia do pedido
            mostrarModalProgress("Carregando informações do pedido");
            //Salvando dados iniciais do pedido em um novo e na tela
            buscarClientes(location.state.Pedido.codcli, history)
                .then((cliente: Cliente[]) => {
                    for (let index = 0; index < cliente.length; index++) {
                        const element = cliente[index];
                        if (element.codcli === location.state.Pedido.codcli) {
                            setFieldCliente(element);
                            buscarCondPGTO(location.state.Pedido.codcpg, "", history)
                                .then((condPgto: CondicaoPagamento[]) => {
                                    for (let contCond = 0; index < condPgto.length; contCond++) {
                                        const elementCond = condPgto[contCond];
                                        if (elementCond.codcpg === location.state.Pedido.codcpg) {
                                            setFieldCondPagamento(elementCond)
                                            buscarFormaPGTO(location.state.Pedido.codfpg, "", history)
                                                .then((formaPgto: FormaPagamento[]) => {
                                                    for (let contForm = 0; index < formaPgto.length; contForm++) {
                                                        const elementForm = formaPgto[contForm];
                                                        if (elementForm.codfpg === location.state.Pedido.codfpg) {
                                                            setFieldFormaPagamento(elementForm)
                                                            // Atualizando os itens do pedido com base no pedido anterior
                                                            // O saldo disponível e o preço de tabela serão atualizados depois com a rota de /saldo                                                            
                                                            buscarItensPedido(location.state.Pedido.numped, location.state.Pedido.codemp, history)                                                               
                                                                .then(itens => {
                                                                    mostrarModalProgress("Montando novo Pedido");
                                                                    let temPedido = novoPedido;

                                                                    //Adicionando cabeçalho
                                                                    temPedido.cliente = parseInt(cliente[0].codcli);
                                                                    temPedido.cpfcnpj = parseInt(cliente[0].cgccpf);
                                                                    temPedido.nomecliente = cliente[0].nomcli;
                                                                    temPedido.condpag = parseInt(condPgto[0].codcpg);
                                                                    temPedido.nomecondpag = condPgto[0].descpg;
                                                                    temPedido.formapag = formaPgto[0].codfpg;
                                                                    temPedido.nomeformapag = formaPgto[0].desfpg;

                                                                    //Informações do Representante
                                                                    let user_codrep = "";
                                                                    let user_empresa = "";
                                                                    let user_filial = "";
                                                                    let user_codtab = "";
                                                                    if (getFromSessionStorage("user_codrep") !== null) {
                                                                        // @ts-ignore
                                                                        user_codrep = getFromSessionStorage("user_codrep")
                                                                    } else {
                                                                        mostrarInfoOK("Erro nas Informações do usuário", "Realize o Login novamente");
                                                                    }
                                                                    if (getFromSessionStorage("user_empresa") !== null) {
                                                                        // @ts-ignore
                                                                        user_empresa = getFromSessionStorage("user_empresa")
                                                                    } else {
                                                                        mostrarInfoOK("Erro nas Informações do usuário", "Realize o Login novamente");
                                                                    }
                                                                    if (getFromSessionStorage("user_filial") !== null) {
                                                                        // @ts-ignore
                                                                        user_filial = getFromSessionStorage("user_filial")
                                                                    } else {
                                                                        mostrarInfoOK("Erro nas Informações do usuário", "Realize o Login novamente");
                                                                    }
                                                                    if (getFromSessionStorage("user_codtab") !== null) {
                                                                        // @ts-ignore
                                                                        user_codtab = getFromSessionStorage("user_codtab")
                                                                    } else {
                                                                        mostrarInfoOK("Erro nas Informações do usuário", "Realize o Login novamente");
                                                                    }
                                                                    temPedido.representante = parseInt(user_codrep);
                                                                    temPedido.empresa = parseInt(location.state.Pedido.codemp);
                                                                    temPedido.filial = parseInt(user_filial);

                                                                    //Por enquanto a informação de tipo de frete não vem na rota /infopedidos
                                                                    //Ela vai precisar vir lá, caso queira trazer na cópia
                                                                    temPedido.tipofrete = "X";
                                                                    temPedido.transportadora2 = parseInt(location.state.Pedido.codtra);
                                                                    temPedido.dataentrega = hoje();

                                                                    let temProdutos: ArrayProdutosNovoPedido = [];
                                                                    for (let index = 0; index < itens.length; index++) {
                                                                        const element = itens[index];
                                                                        //Por enquanto a cópia não trás a quantidade de corte dos itens do pedido
                                                                        //Para isso ser possível, na rota /infopedidoprodutos precisaria trazer essa informação
                                                                        //let corte = location.state.Pedido.pedcrt.toLowerCase() === "s" ? 1 : 0

                                                                        temProdutos.push({
                                                                            "empresa": location.state.Pedido.codemp,
                                                                            "produto": element.codpro,
                                                                            "derivacao": element.codder,
                                                                            "quantidade": parseFloat(element.qtdped),
                                                                            "container": location.state.Pedido.codctn,
                                                                            "precoTabela": 0,
                                                                            "tabela": user_codtab,
                                                                            "preco": parseFloat(element.preuni),
                                                                            "nomeproduto": element.nompro ? element.nompro : 'Nao Identificado 3',
                                                                            "disponibilidade": 0,
                                                                            "desconto": 0,
                                                                            "representante": parseInt(user_codrep),
                                                                            "agrupamento": element.codclc,
                                                                            "quantidadecorte": 0,
                                                                            "nomederivacao": element.nomder,
                                                                            "previsaocontainer": hoje()
                                                                        })
                                                                    }

                                                                    //Adicionando informações dos itens
                                                                    temPedido.quantidade = location.state.Pedido.qtdori;
                                                                    temPedido.valor = location.state.Pedido.vlrori;
                                                                    temPedido.itens = itens.length;

                                                                    //Salvando pedido finalizado no hook
                                                                    if (temProdutos.length > 0) {
                                                                        temPedido.produtos = temProdutos;
                                                                        
                                                                        console.log(temPedido.empresa.toString());

                                                                        mostrarModalProgress("Salvando Pré-Pedido");
                                                                        salvarPrePedido(temPedido, history)
                                                                            .then(prepedido => {
                                                                                atualizaSaldoPrePedido(prepedido, history)
                                                                                    .then((saldo: any) => {
                                                                                        setShowModalProgress(false);
                                                                                        handleNext();
                                                                                    })
                                                                                    .catch((err: any) => {
                                                                                        console.log(err);
                                                                                        mostrarInfoOK("Erro ao atualizar saldo do produto", err);
                                                                                    })
                                                                            })
                                                                            .catch(err => {
                                                                                console.log(err);
                                                                                mostrarInfoOK("Erro ao gerar pré-pedido", err);
                                                                            })
                                                                    } else {
                                                                        mostrarInfoOK("Erro ao adicionar itens ao pedido");
                                                                    }
                                                                    setNovoPedido(temPedido);
                                                                })
                                                                .catch(err => {
                                                                    console.log(err);
                                                                    mostrarInfoOK("Erro ao carregar itens do pedido", err);
                                                                })
                                                            break;
                                                        }

                                                        if (contForm === condPgto.length - 1) {
                                                            mostrarInfoOK("A Condição de Pagamento do pedido não está disponível");
                                                        }
                                                    }

                                                })
                                                .catch((err: any) => {
                                                    console.log("Não foi possível atualizar o campo Forma de Pagamento");
                                                    mostrarInfoOK("Não foi possível selecionar o campo Forma de Pagamento");
                                                })
                                            break;
                                        }

                                        if (contCond === condPgto.length - 1) {
                                            mostrarInfoOK("A Condição de Pagamento do pedido não está disponível");
                                        }
                                    }
                                })
                                .catch((err: any) => {
                                    console.log("Não foi possível selecionar a Condição de Pagamento do Pedido");
                                    mostrarInfoOK("Não foi possível selecionar a Condição de Pagamento do Pedido");
                                })
                            break;
                        }
                        if (index === cliente.length - 1) {
                            mostrarInfoOK("O cliente do pedido não está disponível");
                        }
                    }

                })
                .catch((err: any) => {
                    console.log("Não foi possível selecionar o Cliente do Pedido");
                    mostrarInfoOK("Não foi possível selecionar o Cliente do Pedido");
                })
        } else {
            handleReset();
        }
    })

    function apagarPrePedido(id: number) {
        mostrarModalProgress("Deletando pré-pedido " + id);
        deletarPrePedido(id, history)
            .then(res => {
                setShowModalProgress(false);
                handleReset();
            })
            .catch(err => {
                setShowModalProgress(false);
                mostrarInfoOK("Falha ao deletar pré-pedido", err);
            })
    }

    function handleCancelarPrePedido() {
        if (idPrePedido !== undefined) {
            setMensagem(
                <div className='mensagem-info-modal-loading'>
                    <Typography>{`Deseja excluir o pré-pedido ${idPrePedido}?`}</Typography>
                    <div style={{ display: 'flex' }}>
                        <BtnPersonalizado onClick={() => setShowModalInfo(false)} classBtn={"btn-notifications color-default"}>Cancelar</BtnPersonalizado>
                        <BtnPersonalizado onClick={() => [setShowModalInfo(false), apagarPrePedido(idPrePedido)]} classBtn={"btn-notifications color-red"}>Sim</BtnPersonalizado>
                    </div>
                </div>);
            setShowModalInfo(true);
        } else {
            setMensagem(
                <div className='mensagem-info-modal-loading'>
                    <Typography>{`Deseja cancelar a digitação do pedido?`}</Typography>
                    <div style={{ display: 'flex' }}>
                        <BtnPersonalizado onClick={() => setShowModalInfo(false)} classBtn={"btn-notifications color-default"}>Cancelar</BtnPersonalizado>
                        <BtnPersonalizado onClick={() => [setShowModalInfo(false), handleReset()]} classBtn={"btn-notifications color-red"}>Sim</BtnPersonalizado>
                    </div>
                </div>);
            setShowModalInfo(true);
        }
    }

    return (
        <div className="site">
            <Sidebar />
            <div className="main-content">
                <div className="main-content-novo-pedido">
                    <NavBar />
                    <div className={classes.root}>
                        {useMemo(() => {
                            return (
                                <Stepper activeStep={activeStep} orientation="vertical">
                                    {steps.map((label, index) => (
                                        <Step key={label}>
                                            <StepLabel>{label}</StepLabel>
                                            <Typography>{activeStep > index && getStepInfoOption(index)}</Typography>
                                            <StepContent>
                                                <div className={classes.actionsContainer}>
                                                    {activeStep === 4 ? mostrarBotaoAvancar() : <></>}
                                                </div>
                                                <Typography>{getStepContent(index)}</Typography>
                                                <div className={classes.actionsContainer}>
                                                    {activeStep !== 4 ? mostrarBotaoAvancar() : <></>}
                                                </div>
                                            </StepContent>
                                        </Step>
                                    ))}
                                </Stepper>
                            )
                        }, [
                            activeStep,
                            fieldCliente,
                            fieldCondPagamento,
                            fieldFormaPagamento,
                            totalValuePedido,
                            fieldTranportadora2,
                            fieldFrete,
                            fieldDataEntrega,
                            resumosPedidos,
                            selected,
                            loadingResumo,
                            loadingEnviandoERP,
                            showModalProgress,
                            resumosEmEdicao,
                            idPrePedido,
                            processoFinalizado,
                            idItemErro,
                            itensDigitacaoPedido,
                            value,
                        ])}
                    </div>
                </div>
                {activeStep > 0 &&
                    <FooterMenuNovoPedido
                        totalValuePedido={totalValuePedido}
                        qtdToatalItens={totalQuantidadePedido}
                        regraResumo={false}
                        regraEnviar={activeStep === steps.length - 1 && loadingResumo === false && resumosEmEdicao === 0}
                        regraSalvar={activeStep > 0 && itensDigitacaoPedido.length > 0 && activeStep < 4}
                        regraAddItens={activeStep > 0 && listaPedidosEnviados.length === 0 && itensNaoEnviadosERP === true}
                        regraNovoPedido={listaPedidosEnviados.length > 0 || itensNaoEnviadosERP === false}
                        regraCancelar={(listaPedidosEnviados.length === 0 && itensNaoEnviadosERP === true) || activeStep < 4}
                        funcEnviar={enviarPrePedidoParaERP}
                        funcSalvar={salvarAndamentoPedido}
                        funcResumo={() => { }}
                        funcAddItens={addItemFooter}
                        funcNovoPedido={handleReset}
                        funcCancelar={handleCancelarPrePedido}
                    />
                }
            </div>
            <Toaster />
            <ModalAdicionarItemNovoPedido showModal={showModalAddItens} setShowModal={setShowModalAddItens} salvarAndamentoPedido={salvarAndamentoPedido} />
        </div >
    )
}